import { render, staticRenderFns } from "./plate.vue?vue&type=template&id=4ea3b322&scoped=true&"
import script from "./plate.vue?vue&type=script&lang=js&"
export * from "./plate.vue?vue&type=script&lang=js&"
import style0 from "./plate.vue?vue&type=style&index=0&id=4ea3b322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea3b322",
  null
  
)

export default component.exports